<template>
    <div>
        <vButtonGroup
            class="inbound-package"
            style="margin-bottom: 15px; margin-top: 10px"
            v-if="type == 'query'"
        >
            <vButton class="light-content" @click="addnotes">{{
                $t("boss.purchase.add_note", { defaultValue: "添加备注" })
            }}</vButton>
            <vButton
                v-if="formData.errorCode == 2"
                theme="primary"
                @click="reComputed"
                >{{
                    $t("boss.purchase.recalculate_delivery_date", {
                        defaultValue: "重新计算预计交货日期",
                    })
                }}</vButton
            >
        </vButtonGroup>
        <compWrapper
            :title="
                $t('boss.purchase.purchase_requisition', {
                    defaultValue: '采购申请',
                })
            "
            theme="primary"
            class="relative"
        >
            <section class="relative">
                <vForm
                    :label-width="100"
                    :model="formData"
                    class="clearfix margin-15"
                    :class="{ b2corder: type == 'query' }"
                    ref="applicateform"
                >
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_request_number', {
                                    defaultValue: '采购申请编号',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.orderNo }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.document_status', {
                                    defaultValue: '单据状态',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    findRenderLabel(
                                        getOrderStatus,
                                        formData.orderStatus,
                                        "label"
                                    )
                                }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.project', {
                                    defaultValue: '项目',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ getLineName(formData.lineId) }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.project', {
                                    defaultValue: '项目',
                                })
                            "
                            :rules="required"
                            prop="lineId"
                            v-else
                        >
                            <vSelect
                                v-model="formData.lineId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="(item, index) in getNewProductList"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_currency', {
                                    defaultValue: '采购币种',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.currency }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.purchase_currency', {
                                    defaultValue: '采购币种',
                                })
                            "
                            :rules="required"
                            prop="currency"
                            v-else
                        >
                            <vSelect v-model="formData.currency">
                                <vOption
                                    v-for="(item, index) in getAllCurrency"
                                    :value="item.value"
                                    :key="index"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.source_no', {
                                    defaultValue: '来源单号',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.refNo || "--" }}
                            </div>
                            <vInput v-else v-model="formData.refNo"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.expected_shelf_date', {
                                    defaultValue: '预计上架日期',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.expectedNeedDate || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <!-- <vCol span="12" v-else>
                    <vFormItem label='预计需要时间' prop="expectedNeedDate">
                        <vDatepicker v-model="formData.expectedNeedDate" format='yyyy-mm-dd'></vDatepicker>
                    </vFormItem>
                </vCol> -->
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.supplier', {
                                    defaultValue: '供应商',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ getSupplier(formData.supplierId) }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.supplier', {
                                    defaultValue: '供应商',
                                })
                            "
                            prop="supplier"
                        >
                            <vSelect
                                v-model="formData.supplierId"
                                filterable
                                clearable
                            >
                                <vOption
                                    v-for="item in getNewSupplier"
                                    :key="item.key"
                                    :value="item.value"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.warehouse', {
                                    defaultValue: '预计接收仓库',
                                })
                            "
                            prop="supplier"
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{
                                    getWarehouseName(
                                        formData.expectedReceiveWarehouseCode
                                    )
                                }}
                            </div>
                            <vSelect
                                v-else
                                clearable
                                filterable
                                v-model="formData.expectedReceiveWarehouseId"
                                @on-change="
                                    getNewWarehouseCode(
                                        formData.expectedReceiveWarehouseId
                                    )
                                "
                                prop="expectedReceiveWarehouseId"
                            >
                                <vOption
                                    v-for="(
                                        item, index
                                    ) in getFilterDisabledAllWarehouse"
                                    :key="index"
                                    :value="item.value"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query' && SYSID === 1">
                        <vFormItem
                            :label="
                                $t('boss.purchase.submitted_DingTalk', {
                                    defaultValue: '已提交钉钉流程',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{
                                    formData.dingProcessEnable == 1
                                        ? $t("boss.purchase.correct", {
                                              defaultValue: "是",
                                          })
                                        : $t("boss.purchase.deny", {
                                              defaultValue: "否",
                                          })
                                }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.payment_terms', {
                                    defaultValue: '付款条件',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.paymentCondition || "--" }}
                            </div>
                            <vInput
                                v-else
                                v-model="formData.paymentCondition"
                            ></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem
                            :label="
                                $t('boss.purchase.prepayment_ratio', {
                                    defaultValue: '预付款比例（%）',
                                })
                            "
                        >
                            <div v-if="type == 'query'" class="font-weight">
                                {{ formData.paymentRate || "--" }}
                            </div>
                            <vInputNumber
                                v-else
                                type="number"
                                min="0"
                                max="100"
                                :placeholder="
                                    $t('boss.purchase.fill_prepayment_ratio', {
                                        defaultValue:
                                            '如预付款比例为30%，请填写30即可。填入0-100的数',
                                    })
                                "
                                v-model="formData.paymentRate"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="showaccount">
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            v-if="type == 'query'"
                        >
                            <div class="font-weight">
                                {{ formData.channelFlag || "--" }}
                            </div>
                        </vFormItem>
                        <vFormItem
                            :label="
                                $t('boss.purchase.ONITE_channel', {
                                    defaultValue: 'ONSITE渠道',
                                })
                            "
                            :rules="required"
                            prop="channelFlag"
                            v-else
                        >
                            <vSelect
                                clearable
                                filterable
                                v-model="formData.channelFlag"
                            >
                                <vOption
                                    v-for="(item, index) in channelList"
                                    :key="index"
                                    :value="item.accountFlag"
                                    >{{ item.accountFlag }}</vOption
                                >
                            </vSelect>
                        </vFormItem>
                    </vCol>
                    <vCol span="12" v-if="type == 'query'">
                        <vFormItem
                            :label="
                                $t('boss.purchase.notes', {
                                    defaultValue: '备注',
                                })
                            "
                        >
                            <div class="font-weight">
                                {{ formData.remark || "--" }}
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol span="24" v-else>
                        <vFormItem
                            :label="
                                $t('boss.purchase.notes', {
                                    defaultValue: '备注',
                                })
                            "
                        >
                            <vTextarea v-model="formData.remark"></vTextarea>
                        </vFormItem>
                    </vCol>
                </vForm>
            </section>
            <template v-if="type != 'query'" slot="footer">
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="submit('submited')"
                    >{{
                        $t("boss.purchase.save_submit", {
                            defaultValue: "保存并提交",
                        })
                    }}</vButton
                >
                <vButton
                    class="margin-right-20"
                    theme="success"
                    @click="submit"
                    >{{
                        $t("boss.purchase.save_draft", {
                            defaultValue: "保存为草稿",
                        })
                    }}</vButton
                >
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("boss.purchase.cancel", {
                        defaultValue: "取消",
                    })
                }}</vButton>
            </template>
        </compWrapper>
        <!-- 采购申明细 -->
        <compWrapper
            :title="
                $t('boss.purchase.purchase_details', {
                    defaultValue: '采购申请明细',
                })
            "
            theme="info"
        >
            <div
                v-if="formData.orderStatus === 'approved'"
                style="position: absolute; right: 15px; top: 2px"
            >
                <Button
                    class="margin-right-15"
                    type="primary"
                    @click="reduceNumber"
                    >{{
                        $t("boss.purchase.reduce_applications", {
                            defaultValue: "减少申请数量",
                        })
                    }}</Button
                >
                <Button type="warning" @click="autoReduceNumber">{{
                    $t("boss.purchase.application_quantity", {
                        defaultValue: "一键减少申请数量",
                    })
                }}</Button>
            </div>
            <vForm
                :label-width="100"
                class="clearfix margin-15"
                v-if="type != 'query'"
                ref="detailform"
            >
                <vCol span="8">
                    <vFormItem label="ERPSKU" prop="apperpsku" required>
                        <div style="height: 30px">
                            <Select
                                clearable
                                filterable
                                v-model="apperpsku"
                                ref="zierpselect"
                                remote
                                :remote-method="remoteMethod1"
                                :loading="loading1"
                                @on-change="getProductId(apperpsku)"
                            >
                                <Option
                                    v-for="json in erpSkusList"
                                    :value="json.name"
                                    :key="json.id"
                                    >{{ json.name }}</Option
                                >
                            </Select>
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.quantity', {
                                defaultValue: '申请数量',
                            })
                        "
                        prop="appnumber"
                        required
                    >
                        <vInputNumber
                            min="1"
                            v-model="appnumber"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.reference_price', {
                                defaultValue: '参考单价',
                            })
                        "
                    >
                        <vInput v-model="appacount"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.expected_shelf_date', {
                                defaultValue: '预计上架日期',
                            })
                        "
                        prop="expectedNeedDate"
                        required
                    >
                        <vDatepicker
                            v-model="expectedNeedDate"
                            format="yyyy-mm-dd"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.application_remarks', {
                                defaultValue: '申请备注',
                            })
                        "
                    >
                        <vInput v-model="appremark"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vButton
                        class="margin-left-50"
                        theme="primary"
                        @click="adddetail"
                        >{{
                            $t("boss.purchase.add", { defaultValue: "添加" })
                        }}</vButton
                    >
                    <vButton
                        class="margin-left-10"
                        theme="success"
                        @click="importExcel"
                        >{{
                            $t("boss.purchase.info", { defaultValue: "导入" })
                        }}</vButton
                    >
                </vCol>
            </vForm>
            <vCol span="24" class="margin-top-15">
                <div class="margin-left-15 margin-bottom-15">
                    {{
                        $t("boss.purchase.total_SKU_types", {
                            defaultValue: "SKU种数合计",
                        })
                    }}：{{ allnumber }} &nbsp;&nbsp;&nbsp;
                    {{
                        $t("boss.purchase.total_number", {
                            defaultValue: "总数量",
                        })
                    }}：{{ allacount }} &nbsp;&nbsp;&nbsp;
                    {{
                        $t("boss.purchase.total_amount", {
                            defaultValue: "总金额",
                        })
                    }}：{{ allamount }}
                </div>
            </vCol>
            <vCol span="24">
                <vButton
                    class="margin-left-15"
                    v-if="type != 'query'"
                    @click="alertbox"
                    >{{
                        $t("boss.purchase.clear_all", {
                            defaultValue: "全部清除",
                        })
                    }}</vButton
                >
                <vTable
                    class="margin-15"
                    :columns="detailcolumns"
                    :data="datalist2"
                    size="small"
                    ref="tabledetail"
                    border
                ></vTable>
            </vCol>
        </compWrapper>

        <!-- 关联采购单 -->
        <compWrapper
            :title="
                $t('boss.purchase.associated_purchase_order', {
                    defaultValue: '关联采购单',
                })
            "
            theme="info"
            v-if="type == 'query'"
        >
            <vTable
                class="margin-15"
                :columns="contactcolumns"
                :data="datalist3"
                size="small"
                ref="tableaontact"
                border
            ></vTable>
        </compWrapper>

        <!-- 关联钉钉审批 -->
        <compWrapper
            :title="
                $t('boss.purchase.related_DingTalk_approval', {
                    defaultValue: '关联钉钉审批',
                })
            "
            theme="warning"
            v-if="type == 'query'"
        >
            <vTable
                class="margin-15"
                :columns="dingdingcolumns"
                :data="datalist4"
                size="small"
                ref="tableaontact"
                border
            ></vTable>
        </compWrapper>

        <!-- 上传附件 -->
        <compWrapper
            :title="
                $t('boss.purchase.attachment_information', {
                    defaultValue: '附件信息',
                })
            "
            theme="success"
        >
            <vButton
                v-if="type != 'query'"
                class="margin-top-15 margin-left-15"
                theme="primary"
                @click="adddocument"
                >{{
                    $t("boss.purchase.add_attachment", {
                        defaultValue: "添加附件",
                    })
                }}</vButton
            >
            <span v-if="type != 'query'" class="margin-left-10 color-error">{{
                $t("boss.purchase.attachments_uploaded", {
                    defaultValue: "最多传5个附件，超过请压缩后再上传",
                })
            }}</span>
            <vTable
                class="margin-15"
                :columns="doccolumns"
                :data="docList"
                size="small"
                ref="tabledetail"
                border
            ></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper
            :title="
                $t('boss.purchase.operations_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="logList"></compLog>
        </compWrapper>

        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps = {}"
            @on-close="closemodalprops"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </compModal>

        <vModal
            v-model="handle.show"
            :title="handle.title"
            :width="handle.width || 460"
            :showFooter="false"
            @on-cancel="handle = {}"
        >
            <component
                :is="handle.component"
                v-bind="handle"
                v-on="handle.on"
            ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </vModal>

        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                :data="operate.data"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetApplicateOne,
    HttpSaveApplicateOne,
    HttpDeleteApplicateFile,
    HttpGetProductPrice,
    HttpGetApplicateNotes,
    HttpFindByOrgIdAndOrgWarehouseId,
    HttpPODelAttach,
    HttpDelAttachNew,
    HttpGetDingLog,
    HttpBatchGetExpectedDate,
} from "@/service/purchase/purchase";

import { HttpGetErpsku } from "@/service/aftersales/aftersales";
import { HttpSysOpLog } from "@/service/boss/allot";
import comPurchaseOrder from "../../order/update/index";
import compDetail from "./compDetail";
import reduceNumberComponent from "./reduce";
import mixin from "../mixin";
import compLog from "@components/templates/log";

import compSubDing from "./submitding.vue";
export default {
    mixins: [mixin],
    props: ["activeid", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        // compLog: () => import("@components/templates/log"),
        compModal: () => import("@components/templates/modal"),
        compUpload: () => import("@components/templates/upload"),
        comPurchaseOrder,
        compDetail,
        reduceNumberComponent,
        compSubDing,
    },
    data() {
        return {
            SYSID: global.SYSID,
            type: this.$route.params.type,
            id: this.$route.query.id,
            expectedNeedDate: "",
            formData: {
                lineId: "",
                currency: "USD",
                supplierId: "",
                expectedReceiveWarehouseId: "",
                expectedReceiveWarehouseCode: "Other",
            },
            logList: [],
            loading: false,
            loading1: false,
            erpSkusList: [],
            datalist1: [],
            datalist2: [],
            datalist3: [],
            datalist4: [],
            allnumber: 0,
            allacount: 0,
            allamount: 0,
            apperpsku: "",
            appnumber: 1,
            appacount: "",
            appremark: "",
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            operate: {
                id: null,
                title: "",
                show: false,
                actionurl: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
            handle: {
                show: false,
                title: "",
                component: null,
            },
            modalProps: {
                show: false,
            },
            bossUrl: process.env.VUE_APP_APIURL_BOSS,
            proidarr: [],
            docList: [],
            modal1: false,
            showaccount: false,
            channelList: [],
        };
    },
    created() {
        this.update();
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllCurrency",
            "getAllSupplier",
            "getNewDifferentAllProductList",
        ]),
        ...mapGetters("dictionary", [
            "getWarehouseAllList",
            "getFilterDisabledAllWarehouse",
        ]),
        getNewSupplier() {
            return this.getAllSupplier.filter((item) => {
                return item.attach.status === "NORMAL";
            });
        },
        getFileProps() {
            if (this.operate.downexcel) {
                return {
                    data: {
                        sourceId: this.id || 0,
                    },
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS +
                                this.operate.downexcel,
                            {},
                            "download"
                        );
                    },
                };
            } else {
                return {
                    data: {
                        sourceId: this.id || 0,
                    },
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                };
            }
        },
        doccolumns() {
            // let array =
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.attachment_link", {
                        defaultValue: "附件链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        let delButton = "";
                        if (_this.type !== "query") {
                            delButton = h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            );
                        }
                        return h("div", [
                            delButton,
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
        detailcolumns() {
            let _this = this;
            let array = [
                {
                    width: 60,
                    type: "index",
                    title: this.$t("boss.purchase.index", {
                        defaultValue: "序号",
                    }),
                },
                {
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h("strong", "ERPSKU"),
                            ]);
                        } else {
                            return h("div", [h("strong", "ERPSKU")]);
                        }
                    },
                    render(h, { row }) {
                        return <div>{row.erpsku}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h(
                                    "strong",
                                    this.$t(
                                        "boss.purchase.original_application",
                                        {
                                            defaultValue: "原申请数量",
                                        }
                                    )
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t(
                                        "boss.purchase.original_application",
                                        {
                                            defaultValue: "原申请数量",
                                        }
                                    )
                                ),
                            ]);
                        }
                    },
                    render(h, { row }) {
                        return <div>{row.quantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.actual_applications", {
                        defaultValue: "实际申请数量",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {Number(row.quantity) -
                                    Number(row.cancelQuantity) || "--"}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.reference_price", {
                        defaultValue: "参考单价",
                    }),
                    render(h, { row }) {
                        return <div>{(row.price || 0).toFixed(4)}</div>;
                    },
                },
                {
                    // title: '预计需要时间',
                    renderHeader: (h, params) => {
                        if (this.type != "query") {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                }),
                                h(
                                    "strong",
                                    this.$t(
                                        "boss.purchase.expected_shelf_date",
                                        {
                                            defaultValue: "预计上架日期",
                                        }
                                    )
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t(
                                        "boss.purchase.expected_shelf_date",
                                        {
                                            defaultValue: "预计上架日期",
                                        }
                                    )
                                ),
                            ]);
                        }
                    },
                    render(h, { row }) {
                        return <div>{row.expectedNeedDate}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.estimated_delivery_date", {
                        defaultValue: "预计交货日期",
                    }),
                    key: "expectedDeliveryDate",
                },
                {
                    title: this.$t("boss.purchase.total_amount", {
                        defaultValue: "总金额",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {(Number(row.quantity) * row.price).toFixed(4)}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    render(h, { row }) {
                        return <div>{row.remark}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.procured_quantity", {
                        defaultValue: "已申请未采购数量",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {Number(row.quantity) -
                                    Number(row.usedQuantity) -
                                    Number(row.cancelQuantity) <
                                0
                                    ? 0
                                    : Number(row.quantity) -
                                          Number(row.usedQuantity) -
                                          Number(row.cancelQuantity) || "--"}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.cancel_total_quantity", {
                        defaultValue: "取消总数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.cancelQuantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.reason_cancellation", {
                        defaultValue: "取消原因",
                    }),
                    render(h, { row }) {
                        return <div>{row.cancelReason}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render: (h, { row, index }) => {
                        return h("div", [
                            h(
                                "vButton",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove2(index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
            if (this.type == "query") {
                array.splice(12, 1);
            } else {
                array.splice(8, 1);
            }
            return array;
        },
        contactcolumns() {
            let arrclumn = [
                {
                    title: this.$t("boss.purchase.purchase_order_number", {
                        defaultValue: "采购单号",
                    }),
                    render: (h, { row }) => {
                        return h("div", [
                            h(
                                "a",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            this.addAfReason(row.poId);
                                        },
                                    },
                                },
                                row.poOrderNo
                            ),
                        ]);
                    },
                },
                {
                    title: this.$t("boss.purchase.purchase_order_status", {
                        defaultValue: "采购单状态",
                    }),
                    render(h, { row }) {
                        switch (row.poOrderStatus) {
                            case "draft":
                                return this.$t("boss.purchase.draft", {
                                    defaultValue: "草稿",
                                });
                                break;
                            case "submit":
                                return this.$t("boss.purchase.submitted", {
                                    defaultValue: "已提交",
                                });
                                break;
                            case "auditing_pass":
                                return this.$t("boss.purchase.approved", {
                                    defaultValue: "审核通过",
                                });
                                break;
                            case "auditing_refused":
                                return this.$t(
                                    "boss.purchase.review_rejected",
                                    {
                                        defaultValue: "审核驳回",
                                    }
                                );
                                break;
                            case "refused":
                                return this.$t("boss.purchase.rejected", {
                                    defaultValue: "已驳回",
                                });
                                break;
                            case "finished":
                                return this.$t("boss.purchase.completed", {
                                    defaultValue: "已完成",
                                });
                                break;
                            case "canceled":
                                return this.$t("boss.purchase.cancelled", {
                                    defaultValue: "已取消",
                                });
                                break;
                            case "closed":
                                return this.$t("boss.purchase.closed", {
                                    defaultValue: "已关闭",
                                });
                                break;
                        }
                    },
                },
                {
                    title: this.$t("boss.purchase.created_at", {
                        defaultValue: "创建时间",
                    }),
                    render(h, { row }) {
                        return <div>{row.createdAt}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.transfer_purchase_details", {
                        defaultValue: "转采购明细",
                    }),
                    render: (h, { row }) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            this.seeDetail(row.poId);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.view", {
                                    defaultValue: "查看",
                                })
                            ),
                        ]);
                    },
                },
            ];
            return arrclumn;
        },
        dingdingcolumns() {
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.submission_date", {
                        defaultValue: "提交日期",
                    }),
                    key: "submitTime",
                },
                {
                    title: this.$t("boss.purchase.presenter", {
                        defaultValue: "提交人",
                    }),
                    key: "submitName",
                },
                {
                    title: this.$t("boss.purchase.DingTalk_approval", {
                        defaultValue: "钉钉审批编号",
                    }),
                    key: "businessId",
                },
                {
                    title: this.$t("boss.purchase.DingTalk_status", {
                        defaultValue: "钉钉审批状态",
                    }),
                    key: "type",
                },
                {
                    title: this.$t("boss.purchase.approval_details", {
                        defaultValue: "审批明细",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.seedetail(row.ourdetaillist);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.click_view_details", {
                                    defaultValue: "点击查看详情",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        async reComputed() {
            this.modalProps = {
                title: this.$t("boss.purchase.recalculate_delivery_date", {
                    defaultValue: "重新计算预计交货日期",
                }),
                showDesc: true,
                alert: "warning",
                show: true,
                params: {
                    ids: this.id ? this.id : this.activeid,
                },
                ajaxRequest: HttpBatchGetExpectedDate,
                callback: (res) => {
                    this.$VMessage.success(res.message);
                    this.update();
                },
            };
            // this.loading = true;
            // await HttpBatchGetExpectedDate({
            //     ids: this.id ? this.id : this.activeid
            // }).then(res => {
            //     this.loading = false;
            //     this.$VMessage.success(res.message);
            //     this.update();
            // }, err => {
            //     this.loading = false;
            //     this.$VMessage.error(err.message);
            // });
        },
        seedetail(lists) {
            const attrs = {
                columns: [
                    {
                        title: this.$t("boss.purchase.time", {
                            defaultValue: "时间",
                        }),
                        key: "createdAt",
                    },
                    {
                        title: this.$t("boss.purchase.name", {
                            defaultValue: "姓名",
                        }),
                        key: "updatedName",
                    },
                    {
                        title: this.$t("boss.purchase.state", {
                            defaultValue: "状态",
                        }),
                        key: "result",
                    },
                    {
                        title: this.$t("boss.purchase.notes", {
                            defaultValue: "备注",
                        }),
                        key: "remark",
                    },
                ],
                data: lists,
            };
            this.$VModal.default({
                title: this.$t("boss.purchase.view_details", {
                    defaultValue: "查看详情",
                }),
                width: 460,
                showFooter: false,
                render: (h) => {
                    return this.$createElement(compLog, {
                        attrs,
                    });
                },
            });
        },
        reduceNumber() {
            this.modalProps = {
                show: true,
                title: this.$t("boss.purchase.reduce_procurement", {
                    defaultValue: "减少采购数量",
                }),
                showFooter: false,
                width: 1000,
                component: reduceNumberComponent,
                type: 1,
                id: this.id,
                dataList: this.datalist2,
                on: {
                    "on-success": () => {
                        this.update();
                    },
                },
            };
        },
        autoReduceNumber() {
            this.modalProps = {
                show: true,
                title: this.$t("boss.purchase.click_reduction", {
                    defaultValue: "一键减少采购数量",
                }),
                showFooter: false,
                width: 1000,
                component: reduceNumberComponent,
                type: 2,
                id: this.id,
                dataList: this.datalist2,
                on: {
                    "on-success": () => {
                        this.update();
                    },
                },
            };
        },
        closemodalprops() {
            this.modalProps = {};
            this.$emit("on-openCloseable");
        },
        getLineName(id) {
            let json =
                this.getNewDifferentAllProductList.filter((item) => {
                    return item.value == id;
                })[0] || {};
            return json.label || "--";
        },
        getWarehouseName(code) {
            // console.log(code)
            let itemarr =
                this.getFilterDisabledAllWarehouse.filter((item) => {
                    return item.attach.code == code;
                })[0] || {};

            return itemarr.label || "--";
        },
        getNewWarehouseCode(id) {
            this.getFilterDisabledAllWarehouse.map((item) => {
                if (id === item.value) {
                    this.formData.expectedReceiveWarehouseCode =
                        item.attach.code;
                }
            });
            this.getChannel(this.formData.expectedReceiveWarehouseCode);
        },
        getChannel(wacode) {
            // console.log(wacode)
            let wajsonone =
                this.getFilterDisabledAllWarehouse.filter((item) => {
                    return item.attach.code == wacode;
                })[0] || {};
            // console.log(wajsonone)
            if (wajsonone.attach.warehouseType !== 4) {
                this.showaccount = false;
                return;
            }
            let wareId = wajsonone.value;
            this.showaccount = true;
            HttpFindByOrgIdAndOrgWarehouseId({
                orgId: global.SYSID,
                orgWarehouseId: wareId,
            }).then(
                (res) => {
                    this.channelList = [];
                    this.channelList = res.data;
                },
                (err) => {
                    this.$$VMessage.error(err.message);
                }
            );
        },
        changeProduct(id) {
            let supplierId = "";
            this.getNewProductList.map((item) => {
                if (item.value === id) {
                    supplierId = item.attach.supplierId;
                }
            });
            this.formData.supplierId = supplierId;
        },
        getSupplier(sulierid) {
            let itemarr =
                this.getAllSupplier.filter((item) => {
                    return item.value == sulierid;
                })[0] || {};
            console.log(itemarr);
            if (!itemarr.label) return "--";
            return `${itemarr.label}(${itemarr.attach.code})`;
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        addAfReason(id) {
            this.handle = {
                title: this.$t("boss.purchase.view_purchase_order", {
                    defaultValue: "查看采购单",
                }),
                show: true,
                width: 1100,
                component: "comPurchaseOrder",
                activeid: id,
                querytype: "query",
                showFooter: false,
                comorderno: id + 1,
            };
        },
        addnotes() {
            this.$emit("on-closeCloseable");
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t("boss.purchase.add_note", {
                    defaultValue: "添加备注",
                }),
                width: 460,
                params: { ids: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("boss.purchase.reason_remark", {
                            defaultValue: "备注原因",
                        }),
                        required: false,
                    },
                ],
                ajaxRequest: HttpGetApplicateNotes,
                callback: () => {
                    this.modalProps.show = false;
                    this.update();
                },
            };
        },
        seeDetail(poId) {
            // this.$emit('on-closeCloseable');
            this.handle = {
                title: this.$t("boss.purchase.view_purchase_order", {
                    defaultValue: "查看采购单",
                }),
                show: true,
                width: 600,
                component: "compDetail",
                poId: poId,
                appid: this.id,
                showFooter: false,
                comorderno: poId + 1,
            };
        },
        remoteMethod1(query) {
            this.loading1 = true;
            HttpGetErpsku({
                "search[CN_erpSku]": query,
                rows: 10,
                "search[EQ_lineId]": this.formData.lineId,
                "search[EQ_enable]": 1,
                "search[EQ_status]": 0,
            }).then((res) => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    return {
                        name: item.erpSku,
                        id: item.id,
                        lineId: item.lineId,
                    };
                });
            });
        },
        getProductId(skuid) {
            this.proidarr = this.erpSkusList.filter((item) => {
                return item.name == skuid;
            });
            if (this.formData.supplierId && this.formData.currency) {
                HttpGetProductPrice({
                    productId: this.proidarr[0].id,
                    supplierId: this.formData.supplierId,
                    currency: this.formData.currency,
                }).then(
                    (res) => {
                        if (res.data) {
                            this.appacount = res.data;
                        }
                    },
                    (err) => {
                        this.$Message.error(err.message);
                    }
                );
            }
        },
        adddocument() {
            this.handle = {
                show: true,
                title: this.$t("boss.purchase.add_attachment", {
                    defaultValue: "添加附件",
                }),
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "po_order",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    if (fileList.length > 5) {
                        this.$VMessage.error(
                            this.$t("boss.purchase.package_and_upload", {
                                defaultValue: "附件数量过多，请打包后上传",
                            })
                        );
                        return false;
                    } else {
                        return true;
                    }
                },
                on: {
                    "on-success": (res) => {
                        res.items.map((item) => {
                            this.docList.push(item);
                        });
                        this.handle = {};
                    },
                    "on-cancel": () => {
                        this.handle = {};
                    },
                },
            };
        },
        // 点击导入按钮
        importExcel() {
            this.operate = {
                show: true,
                title: this.$t("boss.purchase.info", {
                    defaultValue: "导入",
                }),
                data: {
                    supplierId: this.formData.supplierId
                        ? this.formData.supplierId
                        : 0,
                    currency: this.formData.currency,
                },
                actionurl: "/api/v2/poRequisition/importItemExcel",
                boxtype: "importexcel",
                downexcel: "/api/v2/poRequisition/downItemExcel",
            };
        },
        alertbox() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: this.$t("boss.purchase.clear_all", {
                    defaultValue: "全部清除",
                }),
                width: 460,
                desc: this.$t("boss.purchase.clear_all_data_table", {
                    defaultValue: "是否清除表格内所有数据?",
                }),
                ajaxRequest: async () => {
                    // console.log(2323232323)
                    this.datalist2 = [];
                    this.allnumber = 0;
                    this.allacount = 0;
                    this.allamount = 0;
                    return {
                        message: this.$t("global.common.haveto_empty", {
                            defaultValue: "已清空",
                        }),
                    };
                },
            };
        },
        compareFN1(date1, date2) {
            //比较日期大小函数
            let oDate1 = new Date(date1);
            let oDate2 = new Date(date2);
            if (oDate1.getTime() < oDate2.getTime()) {
                return -1;
            } else if (oDate1.getTime() > oDate2.getTime()) {
                return 1;
            } else {
                return 0;
            }
        },
        async adddetail() {
            // detailform
            // 验证必填
            // const valid = await this.$refs.detailform.validate()
            // if (!valid) return;
            if (
                this.apperpsku == "" ||
                this.expectedNeedDate == "" ||
                this.expectedNeedDate == ""
            ) {
                this.$VMessage.error(
                    this.$t("boss.purchase.required_information", {
                        defaultValue: "请填写必须信息再点击添加",
                    })
                );
                return;
            }
            let gmttome = this.$moment().tz("GMT").format("YYYY-MM-DD");
            let compare = this.compareFN1(this.expectedNeedDate, gmttome);
            if (compare < 0) {
                this.$VMessage.error(
                    this.$t("boss.purchase.expected_listing", {
                        defaultValue: "预计上架日期不能小于系统日期！",
                    })
                );
                return;
            }
            let itemdata = {
                productId: this.proidarr[0].id,
                lineId: this.proidarr[0].lineId,
                erpsku: this.apperpsku,
                quantity: Number(this.appnumber),
                price: Number(this.appacount),
                // allprice:Number(this.appnumber) * Number(this.appacount),
                remark: this.appremark,
                expectedNeedDate: this.expectedNeedDate,
            };
            // console.log(item)
            if (this.datalist2.length < 1) {
                this.datalist2.push(itemdata);
                this.$set(this.$data, "datalist2", this.datalist2);
            } else {
                let flag = false;

                if (this.datalist2[0].lineId == itemdata.lineId) {
                    this.datalist2.map((json, index) => {
                        // console.log(this.datalist2)
                        if (
                            json.erpsku == itemdata.erpsku &&
                            json.price == itemdata.price &&
                            json.expectedNeedDate == itemdata.expectedNeedDate
                        ) {
                            flag = true;
                            json.quantity += itemdata.quantity;
                            this.getallnumber();
                        } else if (
                            json.erpsku == itemdata.erpsku &&
                            json.price != itemdata.price
                        ) {
                            flag = true;
                            this.$VMessage.error(
                                this.$t("boss.purchase.added_ERPSKU", {
                                    defaultValue:
                                        "添加的ERPSKU的价格与table里面的ERPSKU的价格不同，请重新填写！",
                                })
                            );
                            return;
                        }
                    });
                    if (!flag) {
                        this.datalist2.push(itemdata);
                        this.$set(this.$data, "datalist2", this.datalist2);
                    } else {
                        return;
                    }
                } else {
                    this.$VMessage.error(
                        this.$t("boss.purchase.ERPSKU_project", {
                            defaultValue:
                                "添加的ERPSKU的项目与table里面的ERPSKU的项目不统一，请重新选择！",
                        })
                    );
                    return;
                }
            }

            this.getallnumber();
            // 采购的内容进行清空
            this.apperpsku = "";
            this.appnumber = 1;
            this.appacount = 0;
            this.appremark = "";
        },
        getallnumber() {
            let accounts = 0;
            let amounts = 0;
            let skuArr = [];
            this.datalist2.map((item) => {
                skuArr.push(item.erpsku);
                accounts += Number(item.quantity - (item.cancelQuantity || 0));
                amounts += Number(
                    item.price * (item.quantity - (item.cancelQuantity || 0))
                );
            });
            this.allnumber = new Set(skuArr).size;
            this.allacount = accounts;
            this.allamount = amounts.toFixed(4);
        },
        update() {
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }
            if (this.type == "add") return;
            this.loading = true;
            // 日志
            if (this.type == "query") {
                HttpSysOpLog({
                    "search[EQ_opDataId]": this.id,
                    "search[EQ_opModel]": "po_requisition_order",
                }).then(
                    (res) => {
                        this.logList = res.data.content;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
                if (global.SYSID == 1)
                    HttpGetDingLog({
                        id: this.id,
                        model: "Purchase_Requisition",
                    }).then(
                        (res) => {
                            res.data.map((item) => {
                                item.entity.ourdetaillist = item.list;
                                this.datalist4.push(item.entity);
                            });
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    );
            }
            // 详情
            if (this.type != "add") {
                HttpGetApplicateOne({
                    id: this.id,
                }).then(
                    (res) => {
                        // console.log(res,'9889')
                        this.formData = res.data;
                        this.datalist2 = res.data.poRequisitionItem;
                        this.datalist2.map((item) => {
                            item.lineId = res.data.lineId;
                        });
                        this.datalist3 = res.data.poPurchaseRelateEntityList;
                        this.docList = res.data.meta
                            ? JSON.parse(res.data.meta).items
                            : [];
                        this.getallnumber();

                        // 展示渠道选择
                        if (this.formData.expectedReceiveWarehouseCode != "") {
                            let channelone =
                                this.getFilterDisabledAllWarehouse.filter(
                                    (json) => {
                                        return (
                                            json.attach.code ==
                                            this.formData
                                                .expectedReceiveWarehouseCode
                                        );
                                    }
                                )[0] || {};
                            // console.log(channelone)

                            if (channelone.attach.warehouseType == 4) {
                                this.showaccount = true;
                            } else this.showaccount = false;

                            if (this.type == "edit") {
                                this.getChannel(
                                    this.formData.expectedReceiveWarehouseCode
                                );
                            }
                        }
                        if (this.formData.expectedReceiveWarehouseId == 0) {
                            this.formData.expectedReceiveWarehouseId = "";
                            this.formData.expectedReceiveWarehouseCode =
                                "Other";
                        }
                        this.loading = false;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                        this.loading = false;
                    }
                );
            }
            if (this.type == "edit") {
                this.editshow = true;
                this.showwarehouse = true;
            }
        },
        async submit(typra) {
            // 验证必填
            const valid = await this.$refs.applicateform.validate();
            if (!valid) return;

            let linePaymentType = this.getNewProductList.filter((item) => {
                return item.value === this.formData.lineId;
            })[0];

            // 弹出是否打钩钉钉
            if (typra == "submited" && global.SYSID == 1) {
                this.modalProps = {
                    show: true,
                    alert: "warning",
                    title: this.$t("boss.purchase.is_submit_Ding_Talk", {
                        defaultValue: "是否提交钉钉",
                    }),
                    width: 460,
                    component: "compSubDing",
                    dingval:
                        linePaymentType.attach.paymentType == "payment" ? 1 : 0,
                    showFooter: false,
                    on: {
                        "on-submit": (val) => {
                            // console.log(val)
                            // 点击选择之后才往下走
                            this.formData.dingProcessEnable = val || 0;
                            this.submitupload(typra);
                        },
                        "on-close": () => {
                            this.modalProps = {};
                        },
                    },
                };
            } else {
                this.submitupload(typra);
            }
        },
        submitupload(typra) {
            this.formData.poRequisitionItem = this.datalist2;
            this.formData.amount = this.allamount;

            if (this.formData.expectedReceiveWarehouseCode) {
                let warehouseitem = this.getFilterDisabledAllWarehouse.filter(
                    (item) => {
                        return (
                            item.attach.code ==
                            this.formData.expectedReceiveWarehouseCode
                        );
                    }
                );
                console.log(
                    warehouseitem,
                    this.formData.expectedReceiveWarehouseCode
                );
                this.formData.expectedReceiveWarehouseId =
                    warehouseitem[0].value;
                if (warehouseitem[0].attach.warehouseType !== 4) {
                    this.formData.channelFlag = "";
                }
            }

            let data = {};
            if (typra == "submited") {
                data = {
                    orgId: global.SYSID,
                    ...this.formData,
                    orderStatus: typra,
                };
            } else {
                data = {
                    orgId: global.SYSID,
                    ...this.formData,
                    orderStatus: "draft",
                };
            }
            this.loading = true;
            HttpSaveApplicateOne({
                ...data,
                meta: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : "",
                    organizationId: global.SYSID,
                }),
            }).then(
                (res) => {
                    this.$Message.success(res.message);
                    this.cancel();
                    this.loading = false;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                    this.loading = false;
                }
            );
        },
        remove(index, useId) {
            // 新增时删除附件用另外的接口
            if (this.type === "add") {
                HttpDelAttachNew({
                    id: useId ? index : this.docList[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.docList.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
            // 编辑
            else {
                HttpPODelAttach({
                    id: this.id || 0,
                    attachId: useId ? index : this.docList[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.docList.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
        },
        remove1(index, attachMentId) {
            this.datalist1.splice(index, 1);
            HttpDeleteApplicateFile({
                attachMentId: attachMentId,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.$VMessage.error(res.message);
                }
            );
        },
        remove2(index) {
            this.datalist2.splice(index, 1);
            this.getallnumber();
            // console.log(4545454)
        },
        cancel() {
            this.$router.push({
                name: "applicationList",
            });
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            // 导入后清空现有的数据
            this.datalist2 = [];
            let arrtable = res.data;
            let falgarr = [];
            let newArr = [];

            for (let x = 0; x < arrtable.length; x++) {
                for (let y = arrtable.length - 1; y > x; y--) {
                    if (
                        arrtable[x].erpsku == arrtable[y].erpsku &&
                        arrtable[x].price !== arrtable[y].price
                    ) {
                        return this.$Message.error(
                            this.$t("boss.purchase.added_ERPSKU", {
                                defaultValue:
                                    "添加的ERPSKU的价格与table里面的ERPSKU的价格不同，请重新填写！",
                            })
                        );
                    }
                    // 导入多条合并
                    if (
                        arrtable[x].erpsku == arrtable[y].erpsku &&
                        arrtable[x].expectedNeedDate ==
                            arrtable[y].expectedNeedDate
                    ) {
                        arrtable[x].quantity =
                            arrtable[x].quantity * 1 + arrtable[y].quantity * 1;
                        falgarr.push(y);
                        newArr.push(arrtable[x]);
                    }
                }
            }
            for (let i = 0; i < falgarr.length; i++) {
                arrtable.splice(falgarr[i], 1, {});
            }
            for (let i = 0; i < arrtable.length; ) {
                if (!arrtable[i].erpsku) {
                    arrtable.splice(i, 1);
                } else {
                    i++;
                }
            }
            // 导入后可以追加到表格而不是覆盖的逻辑，目前不需要，以防以后业务变更
            let deleteArr = [];
            for (let i = 0; i < this.datalist2.length; i++) {
                for (let j = 0; j < arrtable.length; j++) {
                    if (this.datalist2[i].erpsku == arrtable[j].erpsku) {
                        if (this.datalist2[i].price != arrtable[j].price) {
                            return this.$Message.error(
                                this.$t("boss.purchase.added_ERPSKU", {
                                    defaultValue:
                                        "添加的ERPSKU的价格与table里面的ERPSKU的价格不同，请重新填写！",
                                })
                            );
                        }
                        if (
                            this.datalist2[i].expectedNeedDate ==
                            arrtable[j].expectedNeedDate
                        ) {
                            this.datalist2[i].quantity =
                                this.datalist2[i].quantity * 1 +
                                arrtable[j].quantity * 1;
                            deleteArr.push(j);
                        }
                    }
                }
            }
            for (let i = 0; i < deleteArr.length; i++) {
                arrtable.splice(deleteArr[i], 1);
            }
            this.datalist2.push(...arrtable);
            this.getallnumber();
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
    },
    filters: {
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach((item) => {
                if (item[key] === val) {
                    text = item[textKey];
                }
            });
            return text;
        },
    },
};
</script>
